import React from "react";
import PublicPageLayout from "./PublicPageLayout";
import HelpContent from "../Common/HelpContent";

/**
 * PublicHelp - Help/Documentation page wrapper for public/unauthenticated users
 * Uses PublicPageLayout for header/footer and HelpContent for the actual content
 */
const PublicHelp = () => {
    return (
        <PublicPageLayout>
            <HelpContent />
        </PublicPageLayout>
    );
};

export default PublicHelp;
